import { ApiClient } from '../../infra';
import { bandPathOf, isCompanyTarget } from './status-bands.types';
/**
 * O que o editor de faixas pede ao servidor.
 *
 * Tres metodos, e so este componente os chama - por isso moram aqui, e nao num
 * servico geral. O caminho depende do NIVEL que se edita (padrao, empresa ou
 * paciente), e quem sabe traduzir isso e `bandPathOf`, ao lado.
 */
export class StatusBandsApi {
    constructor() {
        this.client = ApiClient.INSTANCE;
    }
    static { this.INSTANCE = new StatusBandsApi(); }
    async fetchStatusBands(target) {
        return (await this.client.send('POST', `/measurement_status/${bandPathOf(target)}/search`, {
            measurementTypeId: null,
            ...enderecoDe(target)
        }));
    }
    /** Salva UMA faixa. O backend nao aceita o conjunto de uma vez. */
    async saveStatusBand(target, band) {
        await this.client.send('POST', `/measurement_status/${bandPathOf(target)}`, {
            ...band,
            ...enderecoDe(target)
        });
    }
    /**
     * Devolve o paciente aos padroes, apagando a sobrescrita.
     *
     * Diferente de GRAVAR os padroes nele: gravar o deixa com faixa propria, igual a
     * do padrao naquele instante, e ele para de acompanhar quando o padrao mudar.
     * Apagar o faz voltar a seguir a cadeia - paciente, responsavel, sistema.
     *
     * O servidor apaga so as faixas de quem esta pedindo: a faixa de um paciente
     * pertence a quem a editou.
     */
    async resetStatusBands(target, measurementTypeId) {
        const endereco = enderecoDe(target);
        const partes = Object.entries(endereco).map(([chave, valor]) => `${chave}=${valor}`);
        if (measurementTypeId) {
            partes.push(`measurementTypeId=${measurementTypeId}`);
        }
        const query = partes.length ? `?${partes.join('&')}` : '';
        await this.client.send('DELETE', `/measurement_status/${bandPathOf(target)}${query}`);
    }
}
/**
 * De QUEM sao as faixas - o que o corpo e a query precisam dizer alem do caminho.
 *
 * `tenants` e `defaults` nao dizem nada: um e de quem esta logado, o outro e da
 * plataforma. Os outros dois dizem de quem, e a empresa so quando ha mais de uma -
 * `companyId` nulo quer dizer "a minha", que e o caso de quase todo administrador.
 */
function enderecoDe(target) {
    if (typeof target === 'string') {
        return {};
    }
    if (isCompanyTarget(target)) {
        return target.companyId == null ? {} : { companyId: target.companyId };
    }
    return { patientId: target.patientId };
}
//# sourceMappingURL=status-bands.api.js.map